import axios from 'axios'
import Store from './store'

// const baseURL = 'http://localhost:8000/api/'
const baseURL = 'https://api.bahokbd.com/api/'

// Handling server error
const errorHandler = (error) => {
  if (error.response.status == 401) {
    localStorage.removeItem('accessToken');   
    window.vm.$router.push('/auth/login')
  } else {
    console.log('nooo')
    return error
  }
}

const checkResponse = (response) => {
  if (response.data.status == 401) {
    localStorage.removeItem('accessToken');   
    window.vm.$router.push('/auth/login')
  } else {
    return response
  }
}

export default {
  async execute (method, uri, data, params = {}) {
    const accessToken = localStorage.getItem('accessToken')

    const client = axios.create({
      baseURL: baseURL,
      json: true,
      withCredentials: true
    })

    client.interceptors.response.use(response => checkResponse(response), error => errorHandler(error))

    return client({
      method,
      url: uri,
      data,
      params: params,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        accessuserid: Store.state.authUser.id,
        role_id: Store.state.authUser.role_id
      }
    }).then(req => {
      return req.data
    })
  },
  
  getData (uri, params = {}) {
    return this.execute('get', uri, {}, params)
  },
  getFile (uri, params = {}) {
    const accessToken = localStorage.getItem('accessToken')

    const client = axios.create({
      baseURL: baseURL,
      withCredentials: true
    })

    client.interceptors.response.use(response => checkResponse(response), error => errorHandler(error))

    return client({
      method: 'get',
      url: uri,
      params: params,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        accessuserid: Store.state.authUser.id,
        role_id: Store.state.authUser.role_id
      }
    })
  },
  postData (uri, data) {
    return this.execute('post', uri, data)
  },
  putData (uri, data) {
    return this.execute('put', uri, data)
  },
  deleteData (uri) {
    return this.execute('delete', uri)
  }
}
